import { Installation } from './installations/models/installation.model'

/**
 * creates a function to apply given filter to any object (toFilter)
 */
export const createFilterFunction = (filter: string): ((toFilter: Record<string, unknown>) => boolean) => {
  /**
   * @param toFilter - object in which to search for filter
   */
  const filterFunction = (toFilter: Record<string, unknown>): boolean => {
    return Object.values(toFilter).some(value => {
      if (value === null) return false

      if (Array.isArray(value)) {
        return value.map(value => value.toString().toLowerCase()).some(entry => entry.startsWith(filter))
      }

      const stringValue = typeof value === 'object' ? '' : value + ''

      return stringValue?.toLowerCase().includes(filter)
    })
  }

  return filterFunction
}

/**
 * creates a function to apply given filter to any object (toFilter)
 */
export const createYearFilterFunction = (filter: string): ((toFilter: Installation) => boolean) => {
  /**
   *
   * @param {object} toFilter - object in which to search for filter
   */
  const filterFunction = (toFilter: Installation): boolean => {
    return !!toFilter.createdAt?.startsWith(filter)
  }

  return filterFunction
}

export const asFixedNumber = (value: number, digits = 2): number => Number(value.toFixed(digits))
